import CustomerService from 'common/CustomerService';
import WebHttpService from './WebHttpService';
import config from './../clientConfig';

export default new CustomerService(WebHttpService,config);